<template>
  <z-expansion-config-item 
    :titulo="configuracao.descricao" 
    :subtitulo="configuracao.ajuda"
  >
    <v-select
      v-model="store.configuracoes.CASAS_DECIMAIS_QUANTIDADE"
      dense
      filled
      hide-details
      style="width: 200px"
      :items="[0, 2, 3]"
      @change="updateConfig"
    ></v-select>
  </z-expansion-config-item>
</template>

<script setup>
import { mounted } from 'vue';
import { useConfigStore } from '@/app/store/pinia/configuracoes'
import { globals } from '@/app/globals'

const store = useConfigStore();

const configuracao = {
  config: 'CASAS_DECIMAIS_QUANTIDADE',
  valor: store.configuracoes.CASAS_DECIMAIS_QUANTIDADE,
  tipo: 'integer',
  descricao: 'Número de casas decimais para quantidade',
  ajuda: 'Define o número de casas decimais para quantidade'
}

function updateConfig() {
  configuracao.valor = store.configuracoes.CASAS_DECIMAIS_QUANTIDADE;
  store.salvarConfiguracao(configuracao);
}

</script>

<style lang="scss" scoped>

</style>
